// src/pages/Shared/Chat.jsx
// Generic chat page that wraps ChatWindow for a given enquiry ID
import React from 'react';
import { Box, Container, Button, Typography, CircularProgress } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import ChatWindow from '../../components/Chat/ChatWindow';

const ChatPage = () => {
  const { enquiryId } = useParams();
  const navigate = useNavigate();

  // Check auth
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');
  if (!token || !userStr) {
    return <Navigate to="/login" replace />;
  }

  const handleClose = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      try {
        const user = JSON.parse(userStr);
        if (user.user_type === 'seller') navigate('/seller/messages');
        else navigate('/buyer/messages');
      } catch {
        navigate('/');
      }
    }
  };

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Button startIcon={<ArrowBack />} onClick={handleClose} sx={{ mb: 2 }}>
        Back to Messages
      </Button>
      {enquiryId ? (
        <ChatWindow enquiryId={enquiryId} onClose={handleClose} />
      ) : (
        <Box sx={{ textAlign: 'center', py: 6 }}>
          <Typography color="text.secondary">No enquiry specified.</Typography>
          <Button onClick={handleClose} sx={{ mt: 2 }}>Go Back</Button>
        </Box>
      )}
    </Container>
  );
};

export default ChatPage;
